const settlementInstructionInstructingParty = {
  'si-instructingParty-missing': 'Missing Instructing Party',
  'si-instructingParty-consistent': 'Inconsistent Instructing party identification',
  'si-instructingParty-existence': "The Instructing party doesn't exist",
  'si-instructingParty-active': 'The Instructing party is not active',
};

const settlementInstructionCounterparty = {
  'si-counterparty-missing': 'Please select a counterparty',
  'si-counterparty-consistent': 'Inconsistent Counterparty identification',
  'si-counterparty-existence': "The Counterparty doesn't exist",
  'si-counterparty-active': 'The Counterparty is not active',
};

const settlementInstructionDeliveringParty = {
  'si-deliveringParty-missing': 'Missing Delivering party',
  'si-deliveringParty-consistent': 'Inconsistent Delivering party identification',
  'si-deliveringParty-existence': "The Delivering party doesn't exist",
  'si-deliveringParty-active': 'The Delivering party is not active',
};

const settlementInstructionReceivingParty = {
  'si-receivingParty-missing': 'Missing Receiving party',
  'si-receivingParty-consistent': 'Inconsistent Receiving party identification',
  'si-receivingParty-existence': "The Receiving party doesn't exist",
  'si-receivingParty-active': 'The Receiving party is not active',
  'si-receivingParty-invalid': 'The Receiving party must be the same as Delivering party',
};

const settlementInstructionAsset = {
  'si-iso-isin-missing': 'Missing asset',
  'si-asset-missing': 'Missing asset',
  'si-asset-consistent': 'Inconsistent asset identification',
  'si-asset-existence': "The asset doesn't exist",
  'si-asset-active': 'The asset is not active',
  'si-asset-deleted': 'The asset does not exist',
};

const settlementInstructionCashAccount = {
  'si-cashAccount-consistent': 'Inconsistent cash account identification',
  'si-cashAccount-existence': "The cash account doesn't exist",
  'si-cashAccount-active': 'The cash account is not active',
};

const settlementInstructionSettlementQuantity = {
  'si-quantityAmount': 'Invalid amount/quantity',
  'si-quantityAmount-dvpRvp': 'Invalid amount/quantity',
};

const errorLabels = {
  account: {
    accountRef: {
      required: 'Please enter a value',
      pattern: 'Account ID should be a six digit number not starting from 0',
      'uniqueness-violation': 'This account ID is already in use, please choose another one',
      'pattern-violation': 'Account ID should be a six digit number not starting from 0',
    },
    openingDate: {
      required: 'Please select a date',
      'mandatory-field': 'Missing opening date',
      'account-openingDate-early': 'Invalid, the selected date is in the past',
    },
    closingDate: {
      'account-closingDate-early': 'Invalid, must be later than opening date',
      'account-closingDate-today': 'Invalid, must be later than current date',
    },
    iban: {
      'pattern-violation': 'Invalid IBAN number',
      pattern: 'Invalid IBAN number',
      'uniqueness-violation': 'This IBAN is already in use, please choose another one',
    },
    status: {
      'account-inactive-holdings': 'The account cannot be inactivated because there are non-0 holdings',
      'account-fromDeleted': 'The status of a deleted account cannot be modified',
      'account-status-transition': 'Account status transition is not allowed',
    },
    accountType: {
      required: 'Please select an account',
    },
  },
  currency: {
    name: {
      'pattern-violation': 'Name should be max. 50 characters',
      pattern: 'Name should be max. 50 characters',
      'uniqueness-violation': 'Name already in use',
    },
  },
  member: {
    name: {
      'pattern-violation': 'Name should be max. 50 characters',
      pattern: 'Name should be max. 50 characters',
      'uniqueness-violation': 'Name already in use',
    },
    accountOwnerTransactionId: {
      'si-accountOwnerTransactionId-unique': 'Member Transaction ID is already in use',
    },
    aliasName: {
      'pattern-violation': 'Alias Name should be max. 11 characters',
      pattern: 'Alias Name should be max. 11 characters',
      'uniqueness-violation': 'Alias name already in use',
    },
    bic: {
      'uniqueness-violation': 'BIC already in use',
      'pattern-violation': 'Invalid BIC',
    },
    openingDate: {
      'mandatory-field': 'Missing opening date',
      'member-openingDate-early': 'The opening date is in the past',
    },
    closingDate: {
      'member-closingDate-early': 'The closing date is earlier than the opening dates',
    },
    legalEntity: {
      'mandatory-field': 'Missing legal entity',
      'member-legalEntity-existence': "The legal entity doesn't exist",
    },
    status: {
      'member-inactive-holdings': 'The member cannot be inactivated because there are non-0 holdings in their accounts',
      'member-fromDeleted': 'The status of a deleted entity cannot be modified',
      'member-status-transition': 'Member status transition is not allowed',
    },
  },
  legalEntity: {
    name: {
      'pattern-violation': 'Name should be max. 100 characters',
      pattern: 'Name should be max. 100 characters',
      'uniqueness-violation': 'Name already in use',
    },
    openingDate: {
      'le-openingDate-missing': 'Missing opening date',
      'le-openingDate-early': 'The opening date is in the past',
    },
    closingDate: {
      'le-closingDate-early': 'The closing date is earlier than the opening date',
    },
    countryOfIncorporation: {
      'le-countryIncorporation-missing': 'Missing country of incorporation',
      'pattern-violation': 'Invalid country of incorporation',
    },
    status: {
      'le-fromDeleted': 'The status of a deleted entity cannot be modified',
      'le-status-transition': 'Legal entity status transition is not allowed',
    },
  },
  asset: {
    isin: {
      'uniqueness-violation': 'ISIN already in use',
      'pattern-violation': 'Invalid ISIN',
    },
    localSecurityId: {
      'uniqueness-violation': 'Local security ID already in use',
      'pattern-violation': 'Invalid local security ID',
    },
    fisn: {
      'uniqueness-violation': 'FISN already in use',
      'pattern-violation': 'Invalid FISN',
    },
    jurisdictionOfIssuance: {
      'pattern-violation': 'Invalid jurisdiction of issuance ',
    },
    cfiCode: {
      'pattern-violation': 'Invalid CFI code',
      'asset-cfiCode-consistency': 'CFI code inconsistent with asset type',
    },
    denominationCurrency: {
      'asset-currency-existence': 'The denomination currency does not exist',
    },
    issuerAgent: {
      'asset-issuerAgent-existence': "The issuer agent doesn't exist",
      'asset-issuerAgent-active': 'The issuer agent is not active',
    },
    issuer: {
      'asset-issuer-existence': "The issuer doesn't exist",
      'asset-issuer-active': 'The issuer is not active',
    },
    technicalIssuer: {
      'asset-technicalIssuer-existence': "The technical issuer doesn't exist",
      'asset-technicalIssuer-active': 'The technical issuer is not active',
      'asset-technicalIssuer-missing': 'Missing technical issuer for non-native asset',
    },
    activationDate: {
      'asset-activationDate': 'The activation date is in the past',
    },
    issuanceDate: {
      'asset-issuanceDate-early': 'The issuance date is earlier than the activation date',
    },
    maturityDate: {
      'asset-maturityDate-early': 'The maturity date is earlier than the issuance date',
    },
    expirationDate: {
      'asset-expirationDate-early': 'The expiration date is earlier than the issuance date',
      'asset-maturityExpirationDate': 'The maturity date is later than the expiration date',
    },
    status: {
      'asset-inactive-holdings': 'The asset cannot be inactivated because there are non-0 holdings',
      'asset-fromDeleted': 'The status of a deleted entity cannot be modified',
      'asset-status-transition': 'Asset status transition is not allowed',
    },
    observationShift: {
      pattern: 'Only values between 2 and 9 are allowed',
    },
  },
  corporateActionEvent: {
    declaredRateCurrency: {
      pattern: 'Only uppercase letters (A-Z) are allowed, with a maximum length of 3 characters.',
    },
    issuerDeclaredExchangeRateBaseCcy: {
      pattern: 'Only uppercase letters (A-Z) are allowed, with a maximum length of 3 characters.',
    },
    issuerDeclaredExchangeRateQuotedCcy: {
      pattern: 'Only uppercase letters (A-Z) are allowed, with a maximum length of 3 characters.',
    },
    withholdingTaxRate: {
      pattern: 'Percentage (0-100) up to 15 characters',
    },
  },
  settlementInstruction: {
    settlementAmountCurrency: {
      required: 'Please select a currency',
    },
    counterParty: {
      required: 'Please select a counterparty',
    },
    accountOwnerTransactionId: {
      'si-accountOwnerTransactionId-missing': 'Please enter a value',
      'uniqueness-violation': 'Account owner transaction ID already in use',
      'si-accountOwnerTransactionId-unique': 'ID must be unique per member, max. 16 characters',
    },
    asset: {
      required: 'Please select an asset',
    },
    senderId: {
      'si-iso-sender-inconsistent': 'Inconsistent delivering settlement party identification',
    },
    senderBIC: {
      'si-iso-sender-inconsistent': 'Inconsistent delivering settlement party identification',
    },
    receiverId: {
      'si-iso-receiver-inconsistent': 'Inconsistent receiving settlement party identification',
    },
    receiverBIC: {
      'si-iso-receiver-inconsistent': 'Inconsistent receiving settlement party identification',
    },
    instructingPartyId: settlementInstructionInstructingParty,
    instructingPartyBIC: settlementInstructionInstructingParty,
    counterpartyId: settlementInstructionCounterparty,
    counterpartyBIC: settlementInstructionCounterparty,
    deliveringPartyId: settlementInstructionDeliveringParty,
    deliveringPartyBIC: settlementInstructionDeliveringParty,
    receivingPartyId: settlementInstructionReceivingParty,
    receivingPartyBIC: settlementInstructionReceivingParty,
    assetId: settlementInstructionAsset,
    isin: settlementInstructionAsset,
    safekeepingAccountId: {
      'si-safekeepingAccount-missing': 'Missing safekeeping account',
      'si-safekeepingAccount-existence': "The safekeeping account doesn't exist",
      'si-safekeepingAccount-active': 'The safekeeping account is not active',
    },
    safekeepingAccount: {
      required: 'Please select a safekeeping account',
      'si-safekeepingAccount-missing': 'Please select a safekeeping account',
      'si-safekeepingAccount-existence': "The selected safekeeping account doesn't exist",
      'si-safekeepingAccount-active': 'The selected safekeeping account is not active',
    },
    cashAccountId: settlementInstructionCashAccount,
    cashAccountIban: settlementInstructionCashAccount,
    targetAssetAccountId: {
      'si-targetAssetAccount-missing': 'Please select an asset ',
      'si-targetAssetAccount-existence': "The target asset account doesn't exist",
      'si-targetAssetAccount-active': 'The selected asset account is not active',
    },
    tradeDate: {
      required: 'Please select a date',
      'si-tradeDate-missing': 'Please select a date',
      'si-tradeDate-late': 'Invalid date',
    },
    intendedSettlementDate: {
      required: 'Please select a date',
      'si-settlementDate-missing': 'Missing settlement date',
      'si-settlementDate-early': 'The settlement date is in the past',
      'si-tradeDate-late': 'Trade date is in the future',
      'si-settlementDate-issuanceDate-missing': 'Please select a date',
      'si-settlementDate-issuanceDate': 'The settlement date cannot be earlier than the issuance date',
      'si-quantityAmount': 'Invalid amount/quantity',
    },
    settlementQuantity: {
      ...settlementInstructionSettlementQuantity,
      'si-quantityAmount-pmoRmo': 'Invalid quantity',
      'si-quantity-minimumSettlementUnit': 'The settlement quantity is smaller than minimum settlement unit',
      'si-quantity-settlementUnitMultiple': 'The settlement quantity is not an integer multiple of the settlement unit multiple',
      'si-quantity-deissuanceTotalIssuedQty': 'The settlement quantity must be equal or smaller than the total issued quantity',
      'si-quantity-issuanceTotalAllowedQty':
        'The settlement quantity must be equal or smaller than the Total Allowed Quantity minus the Total Issued Quantity',
    },
    settlementAmount: {
      ...settlementInstructionSettlementQuantity,
      'si-quantityAmount': 'Invalid amount',
      'si-quantityAmount-dvpRvp': 'Invalid amount',
      'si-quantityAmount-pmoRmo': 'Invalid amount',
    },
    accruedInterestIndicator: {
      'si-accruedInterest-amountIndicator': 'Inconsistent accrued interest amount/indicator',
    },
    accruedInterestAmount: {
      'si-accruedInterest-amountIndicator': 'Inconsistent accrued interest amount/indicator',
    },
  },
  paymentInstruction: {
    requestedSettlementDate: {
      required: 'Please select a date',
      'pi-originalSettlementDate-mandatory': 'Please select a date',
    },
    paymentCurrency: {
      required: 'Please select a currency',
      'pi-paymentCurrency-mandatory': 'Please select a currency',
    },
    paymentAmount: {
      'pi-paymentAmount-mantatory': 'Please enter a value',
    },
    transactionId: {
      required: 'Please provide a unique ID',
      'pi-originalTransactionId-mandatory': 'Please provide a unique ID',
      'pi-transactionId-unique': 'ID must be unique per member',
    },
    sourceAccount: {
      required: 'Please select an account',
      'pi-sourceAccount-missing': 'Please select an account',
      'pi-sourceAccount-status': 'The selected account is inactive',
    },
    destinationAccount: {
      'pi-destinationAccount-status': 'Destination account is NOT in valid status',
    },
    instructedAgent: {
      required: 'Please select an instructed agent',
      'pi-instructedAgent-missing': 'Please select an instructed agent',
    },
  },
  tradingParticipant: {
    name: {
      'pattern-violation': 'Trading Participant Name format is not correct.',
      pattern: 'Trading Participant Name format is not correct.',
    },
    tradingParticipantId: {
      'pattern-violation': 'Trading Participant ID must be of exact 4 numbers.',
      pattern: 'Trading Participant ID must be of exact 4 numbers.',
      'uniqueness-violation': 'Trading Participant already set up for the sub-custody service',
    },
  },
  standingSettlementInstruction: {
    name: {
      'pattern-violation': 'SSI Name format is not correct.',
      pattern: 'SSI Name format is not correct.',
    },
  },
  eligibilityOnRestrictedAsset: {
    asset: {
      'uniqueness-violation': 'Eligibility has already been confirmed for this asset',
    },
  },
  taxIncomeCode: {
    code: {
      pattern: 'Exactly 4 characters allowed, consisting only of uppercase letters (A-Z) and digits (0-9).',
    },
    market: {
      pattern: 'Only uppercase letters (A-Z) and digits (0-9) are allowed, with a maximum length of 8 characters.',
    },
    description: {
      pattern: 'At least one and not more than 140 alphanumerical characters are required.',
    },
  },
  taxExemptionCode: {
    code: {
      pattern: 'Exactly 4 characters allowed, consisting only of uppercase letters (A-Z) and digits (0-9).',
    },
    market: {
      pattern: 'Only uppercase letters (A-Z) and digits (0-9) are allowed, with a maximum length of 8 characters.',
    },
    description: {
      pattern: 'At least one and not more than 140 alphanumerical characters are required.',
    },
  },
};
export default errorLabels;
